export default __webpack_public_path__ + "img/introduce.fecbb3b0.png";